import {EntityController} from "./entity-controller";
import { autoinject, LogManager } from 'aurelia-framework';

@autoinject
export class Entities {

	logger = LogManager.getLogger('Entities');
       
    constructor(private controller:EntityController) {
        
    }

	activate(params, routeConfig) {
		this.logger.info("activate");
        this.controller.activate(params, routeConfig);
    }


    

    

    

}

